import { AuditEntity } from "@app/common";
import { Unit, UnitPrice } from "@app/core";
import { Column, Display, prop, propObject, required, Table } from "@messaia/cdk";
import { ProductCategory } from "../enums/product-category";
import { ProductType } from "../enums/product-type";
import { ResellerProductType } from "../enums/resellter-product-type";
import { ProductDetails } from "./product-details";

@Table({
	endpoint: 'product',
	duplicable: true,
	includes: ['Client']
})
export class Product extends AuditEntity {
	@Column()
	@Display($localize`:@@name:Name`)
	@required()
	name: string;

	@required()
	nameIntern: string;

	@Column({ enumType: ProductType, showGtMd: true })
	@Display($localize`:@@type:Type`)
	@required()
	type: ProductType;

	@required()
	resellerProductType: ResellerProductType;

	@required()
	productCategory: ProductCategory;

	@Column({ width: 120, showGtLg: true })
	@Display($localize`:@@articleNumber:Article number`)
	@required()
	sku: string;

	@Column({ name: 'client.displayName', endpoint: 'client?enabled=true&projection=id,name', maxWidth: 250, showGtXl: true })
	@Display($localize`:@@client:Client`)
	@required()
	clientId: number;

	@Column({ event: 'toggle' })
	@Display($localize`:@@enabled:Enabled`)
	@prop()
	enabled: boolean;

	@prop()
	unit: Unit = Unit.Month;

	@prop()
	description: string;

	@required()
	@propObject(UnitPrice)
	regularPrice: UnitPrice = new UnitPrice();

	@prop()
	@propObject(UnitPrice)
	reducedPrice: UnitPrice = new UnitPrice();

	@prop()
	@propObject(UnitPrice)
	shippingCost: UnitPrice = new UnitPrice();

	noticePeriod: number | null;
	imagePath: string;

	@prop()
	image: string;
	thumbnail: string;
	estimatedAvailability: Date | string | null;

	@propObject(ProductDetails)
	details: ProductDetails = new ProductDetails();
}